document.addEventListener('DOMContentLoaded', function() {

  // Add lightgallery to block gallery
  if (typeof lightGallery !== 'undefined') {
    document.querySelectorAll('.wp-block-gallery').forEach(gallery => {
      lightGallery(gallery, {
        selector: '.wp-block-image img', // Selector for gallery items
        thumbnail: true,
        zoom: true,
        licenseKey: '2A6E6328-72AD-4CB4-8D1C-EA56CC30E2E9',
        supportLegacyBrowser: false
      });
    });
  }

});